import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { SlipTable } from './components';
import axios from 'axios';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  paperStyle: {
    margin: theme.spacing(5),
    padding: theme.spacing(5),
    fontSize: "30px",
    textAlign: "center"
  }
}));

const SlipReport = () => {
  const [profile] = useState(JSON.parse(localStorage.getItem('profile')));
  const [citizen_id, setCitizen_id] = useState(profile.person.citizen_id);
  const [tableHeader, setTableHeader] = useState([]);
  const [slipData, setSlipData] = useState([]);
  const [slipMonth, setSlipMonth] = useState([]);
  const [token] = useState(JSON.parse(localStorage.getItem('token')));
  let source = axios.CancelToken.source();

  const loadMoneyType = async (citizen_id) => {
    try {
      const url = 'https://eslip.snru.ac.th/backend/api/eslipData/groupMoneyType/' + citizen_id;
      const result = await axios(url, {
        headers: {
          Authorization: 'Bearer ' + token.access_token
        },
        cancelToken: source.token
      });
      return (result.data.data)
    } catch (error) {

    }
  };

  const loadSlipData = async (citizen_id) => {
    try {
      const url = 'https://eslip.snru.ac.th/backend/api/eslipData/sumSalaryOfMonth/' + citizen_id;
      const result = await axios(url, {
        headers: {
          Authorization: 'Bearer ' + token.access_token
        },
        cancelToken: source.token
      });
      return (result.data.data)
    } catch (error) {

    }
  };
  const loadMonth = async (citizen_id) => {
    try {
      const url = 'https://eslip.snru.ac.th/backend/api/eslipData/groupMonth/' + citizen_id;
      const result = await axios(url, {
        headers: {
          Authorization: 'Bearer ' + token.access_token
        },
        cancelToken: source.token
      });
      return (result.data.data)
    } catch (error) {

    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data1 = await loadMoneyType(citizen_id);
        setTableHeader(data1);
        const data2 = await loadSlipData(citizen_id);
        setSlipData(data2);
        const data3 = await loadMonth(citizen_id);
        setSlipMonth(data3);
        return () => {
          source.cancel();
        };
      } catch (error) {
        console.log(error)
      }
    }
    fetchData();
  }, [citizen_id]);

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div >
        {/*<Paper className={classes.paperStyle}>
          !!! ขออภัยในความไม่สะดวก ระบบกำลังปรับปรุงข้อมูล ระบบจะใช้งานได้เร็ว ๆ นี้ !!!
        </Paper>*/}
        {<SlipTable tableHeader={tableHeader} slipData={slipData} slipMonth={slipMonth} />}
      </div>
    </div>
  );
};

export default SlipReport;